// import React from "react";
import { useState } from "react";
import InnerHero from "../components/InnerHero";
import productsData from "../data/products";
import ProductModal from "../components/ProductCard";
import UsageSafety from "../components/UsageSafety";
import CTASection from "../components/CTASection";

function PlantGrowthRegulator() {
    const [selectedProduct, setSelectedProduct] = useState(null);

    // 🔹 SIRF INSECTICIDE PRODUCTS
    const insecticideProducts = productsData.filter(
        product => product.category === "Plant Growth Regulator"
    );
    return (
        <>
            <InnerHero
                title="Plant Growth Regulators"
                subtitle="Advanced solutions to enhance plant growth, flowering, fruit setting, and overall crop performance."
                breadcrumb="Home / Products"
                bgImage="/images/img/7.jpg"
            />

            <section className="category-intro-section">
                <div className="container">
                    <div className="row align-items-center">

                        {/* LEFT CONTENT */}
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="category-intro-content">
                                <h6 className="section-subtitle">CATEGORY OVERVIEW</h6>
                                <h2>
                                    Enhanced <span>Plant Growth</span> & Crop Development
                                </h2>

                                <p>
                                    Plant Growth Regulators (PGRs) play an important role in
                                    managing plant growth processes such as germination,
                                    flowering, fruit setting, and overall crop development.
                                    Proper use of PGRs helps improve crop uniformity and
                                    productivity.
                                </p>

                                <p>
                                    Goodweel Crop Care offers a range of plant growth regulators
                                    formulated to support balanced plant growth and stress
                                    management under diverse farming conditions. Our products
                                    are developed through research and validated through
                                    real-field applications.
                                </p>

                                <p>
                                    With precise action and easy application, our PGR solutions
                                    help farmers achieve improved crop quality, better yields,
                                    and consistent plant performance.
                                </p>
                            </div>
                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="col-lg-6">
                            <div className="category-intro-image">
                                <img
                                    src="/images/img/pgr.jpg"
                                    alt="Plant Growth Regulator"
                                    className="img-fluid"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* SECTION HEADING */}
            <div className="container text-center my-5">
                <h2 className="section-title">
                    Our <span>Plant Growth Regulator Products</span>
                </h2>
                <p className="section-desc">
                    Explore our range of plant growth regulators designed
                    to enhance crop growth, flowering, stress tolerance,
                    and overall yield performance.
                </p>
            </div>

            {/* PRODUCTS GRID (CSS SAME AS PRODUCT PAGE) */}
            <div className="container">
                <div className="row">
                    {insecticideProducts.map(product => (
                        <div
                            className="col-lg-3 col-md-4 col-sm-6 mb-4 Product-col"
                            key={product.id}
                        >
                            <div
                                className="product-card"
                                onClick={() => setSelectedProduct(product)}
                            >
                                <img
                                    src={product.image}
                                    alt={product.name}
                                />
                                <div className="product-overlay">
                                    <h6>{product.name}</h6>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* SAFETY CHECK */}
                    {insecticideProducts.length === 0 && (
                        <p className="text-center mt-4">
                            No plant growth regulator products available at the moment.
                        </p>
                    )}
                </div>
            </div>

            {/* PRODUCT DETAILS MODAL (UNCHANGED) */}
            {selectedProduct && (
                <ProductModal
                    product={selectedProduct}
                    close={() => setSelectedProduct(null)}
                />
            )}
            <UsageSafety />
            <CTASection />

        </>
    );
};

export default PlantGrowthRegulator;
